import { render, staticRenderFns } from "./SurveyFormEdit.vue?vue&type=template&id=04fc1064"
import script from "./SurveyFormEdit.vue?vue&type=script&lang=ts"
export * from "./SurveyFormEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports